import React, { Component } from 'react';
import QuoteCard from './QuoteCard';
import moment from 'moment';

class CustomerQuotesTab extends Component {

    render() {
        let quotesElements = [];
        this.props.quotes.sort((quoteA, quoteB) => {
            return moment(quoteB.date_quote_asked, "YYYY-MM-DD").diff(moment(quoteA.date_quote_asked, "YYYY-MM-DD"))
        }).forEach((quote, i) => {
            quotesElements.push(<QuoteCard currentQuote={quote} key={i} />);
        })

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin row without-side-padding">
                {quotesElements}
            </div>
        )
    }
}

export default (CustomerQuotesTab);